import { RejectCandidateSuccessPopup } from '../../PermanentJobsV2/JobOverview';
import { DeclineCandidateSuccessPopup } from '../../PermanentJobsV2/JobOverview/components';

/**
 * Success popup shown after declining a candidate on an onsite-interview job.
 * The migrated (M2M) and legacy popups share the same close behavior, which the
 * caller owns via `onClose`.
 */
export const DeclineSuccessPopups = ({ isEnablePermanentJobM2M, professionalName, onClose }) =>
  isEnablePermanentJobM2M ? (
    <DeclineCandidateSuccessPopup professionalName={professionalName} onClose={onClose} />
  ) : (
    <RejectCandidateSuccessPopup professionalName={professionalName} onClose={onClose} />
  );
